export default class Finance {
    constructor(parent) {
        this.parent = parent;        
        this.hashManager = parent.hashManager;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.client = parent.client;
        this.provider = parent.financeProvider;
        this.params = null;
        this.result = null;
    }

    async getFinanceParams() {
        const capCode = this.pricing.getCarCapCode();
        // const capCode = '2026HR-VHybridElegance11Automatic'; // Temporary hardcoded cap code for MIT testing - to be replaced with dynamic cap code retrieval once MIT is confirmed to be working correctly
        const price = this.pricing.getCarBasePrice({ financeableAdditionalProducts: true });
        const deliveryCharge = this.pricing.getCarBundlePrice({ type: 'deliveryFee' });
        const ved = this.pricing.getCarBundlePrice({ type: 'ved' });
        const firstRegistration = this.pricing.getCarBundlePrice({ type: 'firstRegistrationFee' });
        this.paramsRequest = this.client.getFinanceParams({
            capCode, 
            price, 
            deliveryCharge, 
            ved, 
            firstRegistration
        });

        return this.waitForFinanceParams();
    }

    async waitForFinanceParams() {
        const rawFinanceParamsResponse = await this.paramsRequest;
        const formattedFinanceParamsResponse = rawFinanceParamsResponse?.formatted;
        this.rawParams = rawFinanceParamsResponse?.raw;
        return this.params = formattedFinanceParamsResponse;
    }

    async getFinance() {
        const productToken = this.currentParams?.token;
        const totalDeposit = Number(this.deposit) + Number(this.getFinanceContribution());
        this.financeRequest = this.client.getFinance({
            productToken, 
            term: this.term,
            customerContribution: this.deposit,
            deposit: totalDeposit,
            depositPercent: this.currentParams?.depositDefaultValue,
            usage: this.mileage ?? 0,
            capCode: this.currentParams?.capCode, // capCode is the financeCode
            financeType: this.currentParams?.financeTypeCode,
            price: this.pricing.getCarBasePrice({ financeableAdditionalProducts: true }),
            colourCost: this.pricing.getCarColourTrimPrice(),
            accessoriesCost: this.pricing.getCarAccessoriesPrice(),
            selectedProduct: this.currentParams,
        });
         
        return this.waitForFinance();
    }

    async waitForFinance() {
        const rawFinanceResponse = await this.financeRequest;
        const formattedFinanceResponse = rawFinanceResponse?.formatted;
        this.rawResult = rawFinanceResponse?.raw;
        return this.result = formattedFinanceResponse;
    }

    getCurrentParams() {
        if(this.provider === 'CALMS') {
            this.rawCurrentParams = this.rawParams?.products?.find((p) => this.mapFinanceType(p.financeTypeCode) === this.type);
        } else if (this.provider === 'MIT') {
            this.rawCurrentParams = this.rawParams?.financingOptions?.find((p) => p.financeType === this.type);
        }
        return this.currentParams = this.params?.products?.find((p) => p.financeTypeCode === this.type);
    }

    mapFinanceType(FinanceType) {
        const typeMapping = {
            'CONTRACT_PURCHASE': 'PCP',
            'HIRE_PURCHASE': 'HP',
            'KML': 'KML'
        };
        return typeMapping[FinanceType] || FinanceType;
    }

    fromUrl() {
        this.type = this.hashManager.get('payment');
        this.deposit = this.hashManager.get('deposit');
        this.term = this.hashManager.get('term');
        this.mileage = this.hashManager.get('mileage');
    }

    toUrl() {
        this.hashManager.set('payment', this.type);
        this.deposit ? this.hashManager.set('deposit', this.deposit) : this.hashManager.remove('deposit');
        this.mileage ? this.hashManager.set('mileage', this.mileage) : this.hashManager.remove('mileage');
        this.term ? this.hashManager.set('term', this.term) : this.hashManager.remove('term');
        this.hashManager.update();
    }

    update(finance) {
        this.type = finance.type;
        this.deposit = finance.deposit;
        this.term = finance.term;
        this.mileage = finance.mileage;
    }

    getFinanceContribution() {
        return Number(this.currentParams?.fda ?? 0);
    }

    getOTP() {
        return this.currentParams
            ?.vaps
            ?.categories?.find((c) => c?.category === 'OPTION_TO_PURCHASE_FEE')
            ?.vaps?.find((c) => c?.description?.startsWith('OTP#'))
            ?.description
            ?.split('#')?.[1];
    }

    getExcessMileage() {
        return this.currentParams
            ?.vaps
            ?.categories?.find((c) => c?.category === 'OTHER_NON_INSURANCE')
            ?.vaps?.find((c) => c?.description?.startsWith('EM#'))
            ?.description
            ?.split('#')?.[1];
    }
}
